/** Normalize thrown values without allowing diagnostics to cause a second exception. */
export const getErrorObject = (value: unknown): Error => {
  try {
    if (value instanceof Error) return value;
    if (value && typeof value === 'object') {
      const seen = new WeakSet<object>();
      const serialized = JSON.stringify(value, (_key, item: unknown) => {
        if (typeof item === 'bigint') return item.toString();
        if (item && typeof item === 'object') {
          if (seen.has(item)) return '[circular]';
          seen.add(item);
        }
        return item;
      });
      return new Error(serialized ?? 'Unserializable thrown value');
    }
    return new Error(String(value));
  } catch {
    // Getters, proxies, toJSON and string coercion can themselves throw secrets.
    return new Error('Unserializable thrown value');
  }
};
